import { BASE, axiosCall, MethodType } from "./base";
import store from "@/store";

const CONTENT_BASE = `${BASE}canvas-groups/`;
const CONTENT_GROUPS = `${CONTENT_BASE}v2/groups`;

/**
 * Performs a preflight check and prepares the payload for API calls.
 *
 * @param {Object} payload - The payload for the API request.
 * @returns {Object|undefined} - The modified payload or undefined if preflight fails.
 */
function preflight(payload = {}) {
  if (!BASE) {
    console.error("[API] Base API URL is not set.");
    return;
  }

  if (!import.meta.env.VITE_GROUPSET_NAME) {
    console.error("[API] Groupset Name is not set.");
    return;
  }

  payload.groupset_name = import.meta.env.VITE_GROUPSET_NAME;

  if (!store.getters.getCourseId) {
    console.error("[API] Course ID is not set.");
    return;
  }
  //console.log("CourseId", store.getters.getCourseId);
  payload.course_id = store.getters.getCourseId;

  return payload;
}

/**
 * Creates a new content entry.
 *
 * @param {Object} data - The data for the new content entry.
 * @returns {Promise} A promise that resolves with the API response or rejects if the preflight check fails.
 */
function createGroup(data) {
  let payload = preflight();

  if (!payload) {
    console.error("[API] Create Content Entry could not run.");
    return Promise.reject(new Error("Preflight failed"));
  }

  payload = { ...payload, ...data };
  //payload.payload = JSON.stringify({ ...data });

  return axiosCall(MethodType.POST, CONTENT_GROUPS, payload)
    .then((response) => {
      console.log("Create Content Entry Response:", response);
      return response;
    })
    .catch((error) => {
      console.error(
        "Error in Create Content Entry:",
        error.response?.data || error
      );
      throw error;
    });
}

/**
 * Read groups from a Canvas course
 *
 * @returns {Promise} A promise that resolves with the API response or rejects if the preflight check fails.
 */
function readGroups() {
  let payload = preflight();
  if (!payload) {
    console.error("[API] Read Groups could not run.");
    return Promise.reject(new Error("Preflight failed"));
  }

  //todo -- handle differently,
  const url =
    `${CONTENT_GROUPS}` +
    `?groupset_name=${encodeURIComponent(payload.groupset_name)}` +
    `&course_id=${encodeURIComponent(payload.course_id)}`;

  // Make GET request using axios
  return axiosCall(MethodType.GET, url)
    .then((response) => {
      console.log("Read Groups Response:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error in Read Groups:", error.response?.data || error);
      throw error;
    });
}

export { createGroup, readGroups };
